import React from 'react';

import {Card, } from "@mui/joy";


import Link from "@mui/joy/Link";

// icons
import LinkIcon from "@mui/icons-material/Link";


class MessageLink extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    async componentDidMount() {
    }


    render() {
        return (
            <Card
                size={'sm'}
                variant={'soft'}
                sx={{
                    borderRadius: '16px',
                }}
                orientation={'horizontal'}
            >
                <LinkIcon
                    sx={{
                        fontSize: '20px'
                    }}
                />
                <Link
                    noWrap
                    href={this.props.message.content}
                    target={'_blank'}
                    sx={{
                        wordBreak: 'break-word'
                    }}
                >
                    {this.props.message.content}
                </Link>
            </Card>
        )
    }
}

export default MessageLink
